import { Reaction } from 'mobx';
function augment(object, key, func) {
    var origMethod = object[key];
    object[key] = function () {
        func.apply(this, arguments);
        if (origMethod) {
            return origMethod.apply(this, arguments);
        }
    };
}
var mobxReaction = Symbol('mobxReaction');
export function observer(comp) {
    var componentClass = comp;
    augment(componentClass.prototype, 'componentWillMount', function () {
        var _this = this;
        var compName = this.constructor.displayName ||
            this.constructor.name;
        this[mobxReaction] = new Reaction(compName + ".render()", function () {
            return _this.forceUpdate();
        });
    });
    augment(componentClass.prototype, 'componentWillUnmount', function () {
        this[mobxReaction].dispose();
        this[mobxReaction] = null;
    });
    var origRender = componentClass.prototype.render;
    componentClass.prototype.render = function () {
        var _this = this;
        var args = arguments;
        var renderResult;
        this[mobxReaction].track(function () {
            renderResult = origRender.apply(_this, args);
        });
        return renderResult;
    };
}
//# sourceMappingURL=observer.js.map


// WEBPACK FOOTER //
// ../~/preact-mobx/dist/observer.js